// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2C_gG","search":"Settings_search__10uM_","filter":"Settings_filter__fCS3Z"};